import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RxAccordionModule } from '@nrwl/rx-accordion';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxFormBuilderModule } from '@nrwl/rx-form-builder';
import { RxFormsBrowserComponent } from './rx-forms-browser.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxUiModule } from '@nrwl/rx-ui';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    RxUiModule,
    MatExpansionModule,
    DragDropModule,
    RxButtonModule,
    RxIconModule,
    RxFormBuilderModule,
    MatListModule,
    RxAccordionModule,
    RxFormsBrowserComponent,
  ],
  exports: [RxFormsBrowserComponent],
})
export class RxFormsBrowserModule {}
